// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'fx-customer-rate.page.title': 'Foreign Exchange Rates',
    'fx-customer-rate.page.archive.title': 'Archived Foreign Exchange Rates',
    'fx-customer-rate.page.search_results': 'Search Results',
    'fx-customer-rate.page.create.title': 'Create New Rate',
    'fx-customer-rate.page.search.title': 'Find Foreign Exchange Rates',
    'fx-customer-rate.page.edit.title': 'Edit Rate',
    'fx-customer-rate.page.view.title': 'View Rate',
    'fx-customer-rate.page.all': 'All',

    'fx-customer-rate.button.cancel': 'Cancel',
    'fx-customer-rate.button.select': 'Select',
    'fx-customer-rate.button.find': 'Find Foreign Exchange Rates',
    'fx-customer-rate.button.search': 'Apply',
    'fx-customer-rate.button.create': 'Save',
    'fx-customer-rate.button.new': 'New Rate',
    'fx-customer-rate.button.save': 'Save Changes',
    'fx-customer-rate.button.archive': 'Archive',
    'fx-customer-rate.button.delete': 'Permanently Delete',
    'fx-customer-rate.button.edit': 'Edit',
    'fx-customer-rate.button.restore': 'Restore',
    'fx-customer-rate.button.reset': 'Reset',

    'fx-customer-rate.placeholder.search': 'Search exchange rates',

    'fx-customer-rate.link.create_first_fx_customer_rate': 'Click here to create your first exchange rate',
    'fx-customer-rate.link.fx_customer_rates': ' Return to Foreign Exchange Rates',
    'fx-customer-rate.link.archive': 'Archived Foreign Exchange Rates',
    'fx-customer-rate.link.retry': 'Click here to retry',

    'fx-customer-rate.checkbox.all': 'Check All',
    'fx-customer-rate.checkbox.actions_label': 'with selected',

    'fx-customer-rate.label.from__trading_date': 'From trading date',
    'fx-customer-rate.label.to__trading_date': 'To trading date',
    'fx-customer-rate.label.trading_date': 'Trading Date',

    'fx-customer-rate.label.from_fx_currency_name': 'From Currency',
    'fx-customer-rate.label.to_fx_currency_name': 'To Currency',

    'fx-customer-rate.label.usd': 'USD',
    'fx-customer-rate.label.fx_rate': 'Exchange Rate',

    'fx-customer-rate.sort.field_label': 'Field',
    'fx-customer-rate.sort.direction_label': 'Direction',
    'fx-customer-rate.sort.direction_ascending': 'Ascending',
    'fx-customer-rate.sort.direction_descending': 'Descending',

    'fx-customer-rate.modal.title.fx_customer_rate_archive': 'Archive Rate',
    'fx-customer-rate.modal.title.fx_customer_rate_delete_permanently': 'Delete Rate',
    'fx-customer-rate.modal.title.fx_customer_rate_restore': 'Restore Rate',
    'fx-customer-rate.modal.title.confirm_update': 'Update Rate',

    'fx-customer-rate.modal.message.fx_customer_rate_archive': 'Are you sure that you want to move this exchange rate to the archive? | Are you sure that you want to move these exchange rates to the archive?',
    'fx-customer-rate.modal.message.fx_customer_rate_delete_permanently':
        'Are you sure that you want to permanently delete this exchange rate? This action cannot be undone. | Are you sure that you want to permanently delete these exchange rates? This action cannot be undone.',
    'fx-customer-rate.modal.message.fx_customer_rate_restore': 'Are you sure that you want to restore this exchange rate? | Are you sure that you want to restore these exchange rates?',
    'fx-customer-rate.modal.message.confirm_update': 'Are you sure that you want to change this exchange rate? It won’t change transactions already done.',

    'fx-customer-rate.success.message.fx_customer_rate_created': 'Your exchange rate has been created',
    'fx-customer-rate.success.message.fx_customer_rate_updated': 'Your exchange rate has been updated',
    'fx-customer-rate.success.message.fx_customer_rate_restored': 'Your exchange rate has been restored | All selected exchange rates were restored',
    'fx-customer-rate.success.message.fx_customer_rate_deleted': 'Your exchange rate has been permanently deleted | All selected exchange rates were permanently deleted',
    'fx-customer-rate.success.message.archived_fx_customer_rates': 'Your exchange rate was moved to the archive | All selected exchange rates were moved to the archive',

    'fx-customer-rate.error.message.archived_fx_customer_rates': 'This exchange rate was already moved to the archive | These exchange rates were already moved to the archive',
    'fx-customer-rate.error.message.fx_customer_rate_deleted': 'This exchange rate was already permanently deleted | These exchange rates were already permanently deleted',
    'fx-customer-rate.error.message.fx_customer_rate_restored': 'This exchange rate was already restored | These exchange rates were already restored',
    'fx-customer-rate.error.message.error_loading_page': 'Sorry, there was an error loading exchange rate.| Sorry, there was an error loading exchange rates.',

    'fx-customer-rate.message.search.no_archived_fx_customer_rates': "You don't have any archived exchange rates.",
};
